import {
  notification as AntNotification,
  // Form, Input, Space, Switch, Descriptions, Switch, Row, Col, Button, Tooltip,
} from 'antd'
// import {
//   DeleteOutlined,
//   EditOutlined
// } from '@ant-design/icons'

import { store as reduxStore } from 'index'

import { mailApiError } from 'utils/ui'

// import { emailAddress } from 'utils';

import { mailAdminClient, restClient } from 'myNet'

import Ngql from 'gql/ninegql'
import AppConfigQuery from 'pages/appconfig/query'
import WorkspaceQuery from 'pages/workspace/query'

import { getOfficemailDomain } from './info'
import getDefaultAppConfig from './defaultAppConfig'

export async function activateInternal(options) {
  const { domain, workspaceId, type, values } = options

  let ret = false
  try {
    ret = await checkAppConfig()
    if (ret === true) {
      ret = await createAppConfig(domain, type, values)
    }
    if (ret === true) {
      ret = await createAllowDomain(domain)
    }
    if (ret === true) {
      ret = await createAutodiscover(domain)
    }
    if (ret === true) {
      ret = await createMailboxDomain(domain, workspaceId)
    }
    if (ret === true) {
      ret = await updateOnBoarding()
    }
  } catch (e) {
    console.log(e)
    // AntNotification.error({
    //   message: 'Error',
    //   description: e.message
    // });
    // return Promise.reject(e);
    ret = false
  }

  return ret
}

export async function activateExternal(options) {
  const { domain, type, values } = options

  let ret = false

  try {
    ret = await checkAppConfig()
    if (ret === true) {
      ret = await createAppConfig(domain, type, values)
    }
    if (ret === true) {
      ret = await createAllowDomain(domain)
    }
    if (ret === true) {
      ret = await createAutodiscover(domain)
    }
    if (ret === true) {
      ret = await updateOnBoarding()
    }
  } catch (e) {
    console.log(e)

    // AntNotification.error({
    //   message: 'Error',
    //   description: e.message
    // });

    // return Promise.reject(e);
    ret = false
  }

  return ret
}

export function checkAppConfig() {
  const reduxState = reduxStore.getState()
  const { workspace } = reduxState.user

  return new Promise((resolve, reject) => {
    Ngql.GQLObj(AppConfigQuery.queryAppConfigList, {
      name: 'appConfig',
      useUI: false,
    })
      .query()
      .then((res) => {
        console.log(' checkAppConfig - ', res)
        if (res.data.allAppconfigs.totalCount > 0) {
          const ids = res.data.allAppconfigs.edges.map((item) => {
            return item.node.id
          })

          Ngql.GQLObj(AppConfigQuery.mutationDeleteAppConfig, {
            vars: {
              appconfigGids: ids,
              workspaceGid: workspace.gid,
            },
          })
            .mutate()
            .then((res2) => {
              console.log(res2)
              resolve(true)
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          resolve(true)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createAppConfig(domain, type, values) {
  const reduxState = reduxStore.getState()
  const { workspace } = reduxState.user

  const configProps = {
    ...getDefaultAppConfig(type),
    ...values,
  }

  const appconfigData = {
    name: `appconfig for ${domain}`,
    config: JSON.stringify(configProps),
  }

  return new Promise((resolve, reject) => {
    Ngql.GQLObj(AppConfigQuery.mutationCreateAppConfig, {
      vars: {
        appconfigData,
        workspaceGid: workspace.gid,
      },
    })
      .mutate()
      .then(() => {
        resolve(true)
      })
      .catch((e) => {
        AntNotification.error({
          message: 'Error',
          description: e.message,
        })
        reject(e)
      })
  })
}

export function createAllowDomain(domain) {
  // const reduxState = reduxStore.getState();
  // const { workspace } = reduxState.user;

  return new Promise((resolve, reject) => {
    Ngql.GQLObj(WorkspaceQuery.mutationCreateAllowedDomain, {
      vars: {
        domain,
        // allowedDomain,
        // workspaceGid: workspace.gid,
      },
    })
      .mutate()
      .then(() => {
        resolve(true)
      })
      .catch((e) => {
        if (e.extensions != null && e.message.indexOf('Already exist domain') > -1) {
          // 이미 domain이 존재함. - 통과~!
          resolve(true)
        } else {
          AntNotification.error({
            message: 'Error',
            description: e.message,
          })
          reject(e)
        }
      })
  })
}

export function createAutodiscover(domain) {
  // const reduxState = reduxStore.getState();
  // const { workspace } = reduxState.user;

  const mutationCreateAutodiscover = Ngql.Mutation('CreateAutodiscover', {
    createAutodiscover: Ngql.Node(
      {
        ok: true,
        errors: true,
      },
      null,
      false,
      {
        domain: Ngql.Var('domain', 'String!'),
        app: Ngql.Var('app', 'String!'),
        env: Ngql.Var('env', 'String!'),
      },
    ),
  })

  const app = 'officemail'
  const env = process.env.REACT_APP_TARGET === 'production' ? 'prod' : 'dev'

  return new Promise((resolve, reject) => {
    Ngql.GQLObj(mutationCreateAutodiscover, {
      vars: {
        domain,
        app,
        env,
      },
    })
      .mutate()
      .then(() => {
        resolve(true)
      })
      .catch((e) => {
        if (e.extensions != null && e.message.indexOf('Already exist') > -1) {
          // 이미 domain이 존재함. - 통과~!
          resolve(true)
        } else {
          AntNotification.error({
            message: 'Error',
            description: e.message,
          })
          reject(e)
        }
      })
  })
}

export async function createMailboxDomain(domain, workspaceId) {
  // 관리자 계정을 만들기 위해 필요한 정보임. 관리자 계정 만들기가 필요없으므로 주석처리.
  // const reduxState = reduxStore.getState();
  // const { user } = reduxState;

  // const emailObj = emailAddress(user.email);
  // let email = null;
  // if (emailObj.host !== domain) {
  //   email = `admin@${domain}`;
  // } else {
  //   email = user.email;
  // }

  try {
    let res = null
    try {
      res = await mailAdminClient.get('/domains/find', { domain })
    } catch (ex) {
      if (ex.message.indexOf('Unauthorized') > -1 || ex.message.indexOf('Domain not found') > -1) {
        res = {} // domain이 없음.
      } else {
        throw ex
      }
    }

    console.log(' --- /domains : ', res)
    if (res.data == null || res.data.id == null) {
      // res = await mailAdminClient.post('/domains/self');
      res = await mailAdminClient.post('/domains', {
        domain,
        workspace_id: workspaceId,
        quota: 10, // default 10GB.
      })
      console.log(' --- /domain/self : ', res)
      if (res.data == null || res.data.id == null) {
        const message = res.data != null ? res.data.message : ''
        return Promise.reject(new Error(message))
      }
      // domain 생성이 성공하면, spamsniper에 domain 추가.
      const officemailDomain = getOfficemailDomain()
      res = await restClient.post('/v1/spamsniper/add_domain', {
        domain,
        forward_server: `smtp.${officemailDomain}`,
      })
      console.log('/v1/spamsniper/add_domain - ', res)
    }

    // 관리자 계정 만들기는 필요 없음.
    // const { id: domainID } = res.data;
    // res = await mailAdminClient.get(`/domains/${domainID}/accounts/find`, {
    //   account: email,
    // });

    // if (res.data == null || res.data.id == null) {
    //   res = await mailAdminClient.post(`/domains/${domainID}/accounts`, {
    //     account: email,
    //     quota: 5 * 1024 * 1024, // default 5GB.
    //     password: 'admin',
    //     info: `${domain} admin`,
    //   });
    //   if (res.data == null || res.data.id == null) {
    //     const message = (res.data != null) ? res.data.message : '';
    //     return Promise.reject(new Error(message));
    //   }
    // }

    return Promise.resolve(true)
  } catch (err) {
    // AntNotification.error({
    //   message: 'Error',
    //   description: err.message
    // });
    mailApiError(err)
    return Promise.reject(err)
  }
}

export async function updateOnBoarding() {
  try {
    let res = null
    res = await restClient.post('/v1/officenext/onboarding', { status: 'active' })
    console.log('/officenext/onboarding - ', res)
    if (res.data.code === 200) {
      return Promise.resolve(true)
    }

    // 에러 발생 여부와 상관없이 무조건 통과되도록 처리. (officenext 서버에 문제가 발생한 경우, 나중에 다시 등록하도록 처리.)
    // return Promise.resolve(false);
    return Promise.resolve(true)
  } catch (err) {
    console.log(err)
    AntNotification.error({
      message: 'Error',
      description: err.message,
    })
    // 에러 발생 여부와 상관없이 무조건 통과되도록 처리. (officenext 서버에 문제가 발생한 경우, 나중에 다시 등록하도록 처리.)
    // return Promise.reject(err);
    return Promise.resolve(true)
  }
}

const extObj = {
  activateInternal,
  activateExternal,
  checkAppConfig,
  createAppConfig,
  createAllowDomain,
  createAutodiscover,
  createMailboxDomain,
  updateOnBoarding,
}

export default extObj
